export default "__VITE_ASSET__C8A23khP__"